<template>
  <div class="recordDetail">
    <Navbar :appTitle="$route.meta.title"/>
    <!--头部-->
    <div class="d-head">
      <div class="content">
        <div class="left">
          <div class="title">
            <span style="max-width: 7rem;overflow: hidden;text-overflow: ellipsis;">{{ detailInfo.taskCode }}</span>
            <span :class="detailInfo.status">{{ detailInfo.statusText }}</span>
          </div>
          <div class="row">
            <span class="key">单据日期：</span>
            <span class="value">{{detailInfo.docDate || "-"}}</span>
          </div>
          <div v-show="allDownShow">
            <div class="row">
              <span class="key">盘点范围：</span>
              <span
                class="value"
                @click="showInventoryModel(detailInfo.inventoryScopeText)"
              >
                {{detailInfo.inventoryScopeText || "-"}}
              </span>
            </div>
            <div class="row">
              <span class="key">创建人：</span>
              <span class="value">{{detailInfo.createByText || "-"}}</span>
            </div>
            <div class="row">
              <span class="key">创建时间：</span>
              <span class="value">{{detailInfo.createTime || "-"}}</span>
            </div>
            <div class="row">
              <span class="key">盘点人：</span>
              <span class="value">{{detailInfo.submissionByText || "-"}}</span>
            </div>
            <div class="row">
              <span class="key">盘点时间：</span>
              <span class="value">{{detailInfo.submissionTime || "-"}}</span>
            </div>
          </div>

          <div class="ctrBtn-contian" @click="allDownShow = !allDownShow">
            <span v-if="!allDownShow">展开</span>
            <span>
              <van-icon v-if="!allDownShow" name="arrow-down" color="#969696" size="16"/>
            </span>

            <span v-if="allDownShow">收起</span>
            <span>
              <van-icon  v-if="allDownShow" name="arrow-up" color="#969696" size="16"/>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!--tab-->
    <van-tabs v-model="active" :offset-top="158" color="#1890FF">
      <van-tab :title="`全部（${detailInfo.detailList && detailInfo.detailList.length || 0}）`">
        <div class="list" :style="{height: allDownShow ? 'calc(100vh - 395px)' : 'calc(100vh - 242px)'}" v-if="detailInfo.detailList && detailInfo.detailList.length != 0">
          <div
            v-for="(item, index) in detailInfo.detailList"
            :key="index"
            class="wrap"
          >
            <div class="top">
              <div class="icon"></div>
              <div class="title">
                {{ item.goodsCode || '-' }} |
                {{ item.goodsName || '-' }} |
                {{ item.goodsSpec || '-' }}
              </div>
            </div>
            <div class="center">
              <div>
                <p>
                  <span class="key">包装规格：</span>
                  <span class="value">{{ item.packageSpec  || '-' }}</span>
                </p>
                <p>
                  <span class="key">产地：</span>
                  <span class="value">{{ item.address || '-' }}</span>
                </p>
                <p>
                  <span class="key">盘点库位：</span>
                  <span class="value">{{ item.latticeCode || '-' }} | {{ item.latticeName || '-' }}</span>
                </p>
                <p>
                  <span class="key">账面数/盘点数：</span>
                  <span class="value">{{ item.latticeNum }}{{ item.unitIdText }} / {{ item.goodsNum }}{{ item.unitIdText }}</span>
                </p>
                <p>
                  <span class="key">盈亏数：</span>
                  <span class="value">{{ item.profitLossNum }}{{ item.unitIdText }}</span>
                </p>
              </div>
            </div>
            <div class="label">
              <span> {{ item.produceDate  || '-' }} </span>
              <span> {{ item.batchCode  || '-' }} </span>
            </div>
          </div>
        </div>
        <van-empty v-else description="全部为空" />
      </van-tab>
      <van-tab :title="`盘盈（${detailInfo.surplusList && detailInfo.surplusList.length || 0}）`">
        <div class="list" :style="{height: allDownShow ? 'calc(100vh - 395px)' : 'calc(100vh - 242px)'}" v-if="detailInfo.surplusList && detailInfo.surplusList.length != 0">
          <div
            v-for="(item, index) in detailInfo.surplusList"
            :key="index"
            class="wrap"
          >
            <div class="top">
              <div class="icon"></div>
              <div class="title">
                {{ item.goodsCode || '-' }} |
                {{ item.goodsName || '-' }} |
                {{ item.goodsSpec || '-' }}
              </div>
            </div>
            <div class="center">
              <div>
                <p>
                  <span class="key">包装规格：</span>
                  <span class="value">{{ item.packageSpec  || '-' }}</span>
                </p>
                <p>
                  <span class="key">产地：</span>
                  <span class="value">{{ item.address || '-' }}</span>
                </p>
                <p>
                  <span class="key">盘点库位：</span>
                  <span class="value">{{ item.latticeCode || '-' }} | {{ item.latticeName || '-' }}</span>
                </p>
                <p>
                  <span class="key">账面数/盘点数：</span>
                  <span class="value">{{ item.latticeNum }}{{ item.unitIdText }} / {{ item.goodsNum }}{{ item.unitIdText }}</span>
                </p>
                <p>
                  <span class="key">盈亏数：</span>
                  <span class="value">{{ item.profitLossNum }}{{ item.unitIdText }}</span>
                </p>
              </div>
            </div>
            <div class="label">
              <span> {{ item.produceDate  || '-' }} </span>
              <span> {{ item.batchCode  || '-' }} </span>
            </div>
          </div>
        </div>
        <van-empty v-else description="盘盈为空" />
      </van-tab>
      <van-tab :title="`盘亏（${detailInfo.lossList && detailInfo.lossList.length || 0}）`">
        <div class="list" :style="{height: allDownShow ? 'calc(100vh - 395px)' : 'calc(100vh - 242px)'}" v-if="detailInfo.lossList && detailInfo.lossList.length != 0">
          <div
            v-for="(item, index) in detailInfo.lossList"
            :key="index"
            class="wrap"
          >
            <div class="top">
              <div class="icon"></div>
              <div class="title">
                {{ item.goodsCode || '-' }} |
                {{ item.goodsName || '-' }} |
                {{ item.goodsSpec || '-' }}
              </div>
            </div>
            <div class="center">
              <div>
                <p>
                  <span class="key">包装规格：</span>
                  <span class="value">{{ item.packageSpec  || '-' }}</span>
                </p>
                <p>
                  <span class="key">产地：</span>
                  <span class="value">{{ item.address || '-' }}</span>
                </p>
                <p>
                  <span class="key">盘点库位：</span>
                  <span class="value">{{ item.latticeCode || '-' }} | {{ item.latticeName || '-' }}</span>
                </p>
                <p>
                  <span class="key">账面数/盘点数：</span>
                  <span class="value">{{ item.latticeNum }}{{ item.unitIdText }} / {{ item.goodsNum }}{{ item.unitIdText }}</span>
                </p>
                <p>
                  <span class="key">盈亏数：</span>
                  <span class="value">{{ item.profitLossNum }}{{ item.unitIdText }}</span>
                </p>
              </div>
            </div>
            <div class="label">
              <span> {{ item.produceDate  || '-' }} </span>
              <span> {{ item.batchCode  || '-' }} </span>
            </div>
          </div>
        </div>
        <van-empty v-else description="盘亏为空" />
      </van-tab>
      <van-tab :title="`盘平（${detailInfo.flatList && detailInfo.flatList.length || 0}）`">
        <div class="list" :style="{height: allDownShow ? 'calc(100vh - 395px)' : 'calc(100vh - 242px)'}" v-if="detailInfo.flatList && detailInfo.flatList.length != 0">
          <div
            v-for="(item, index) in detailInfo.flatList"
            :key="index"
            class="wrap"
          >
            <div class="top">
              <div class="icon"></div>
              <div class="title">
                {{ item.goodsCode || '-' }} |
                {{ item.goodsName || '-' }} |
                {{ item.goodsSpec || '-' }}
              </div>
            </div>
            <div class="center">
              <div>
                <p>
                  <span class="key">包装规格：</span>
                  <span class="value">{{ item.packageSpec  || '-' }}</span>
                </p>
                <p>
                  <span class="key">产地：</span>
                  <span class="value">{{ item.address || '-' }}</span>
                </p>
                <p>
                  <span class="key">盘点库位：</span>
                  <span class="value">{{ item.latticeCode || '-' }} | {{ item.latticeName || '-' }}</span>
                </p>
                <p>
                  <span class="key">账面数/盘点数：</span>
                  <span class="value">{{ item.latticeNum }}{{ item.unitIdText }} / {{ item.goodsNum }}{{ item.unitIdText }}</span>
                </p>
                <p>
                  <span class="key">盈亏数：</span>
                  <span class="value">{{ item.profitLossNum }}{{ item.unitIdText }}</span>
                </p>
              </div>
            </div>
            <div class="label">
              <span> {{ item.produceDate  || '-' }} </span>
              <span> {{ item.batchCode  || '-' }} </span>
            </div>
          </div>
        </div>
        <van-empty v-else description="盘平为空" />
      </van-tab>
    </van-tabs>
    <!--操作按钮-->
    <div class="search-bottom">
      <div class="searchContain"></div>
      <div class="searchContain">
        <span class="btn cancel" v-if="detailInfo.status == 'FINISH'" @click="revokeProOrLoss">撤销盈亏</span>
        <span class="btn del" v-if="detailInfo.status != 'FINISH'" @click="handleDelete">删除</span>
        <span class="btn cancel" v-if="detailInfo.status == 'PENDING'" @click="handleProOrLoss">盈亏处理</span>
        <span class="btn cancel" v-if="detailInfo.status == 'UN' || detailInfo.status == 'ING'"  @click="handleContinue">继续盘点</span>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navBar/navBar_right";
import pageList from "@/components/pageList";
import {
  itaskDetail,
  deleteItask,
  profitLossOperation,
  revokedProfitLoss
} from "@/api/inventoryOrder";
import store from '@/store'
  import { Dialog } from "vant";

export default {
  name: "inventoryCheckOrderDetail", //入库单详情
  components: { Navbar, pageList },
  data() {
    return {
      active: 0,
      detailInfo: {},
      allDownShow: false
    };
  },
  created() {
    store.commit('SET_CURRENT_PREFIX', '/jksaas-produce/produce')
    this.getDetail();
  },
  methods: {
    showInventoryModel(inventoryScopeText) {
      Dialog.confirm({
        title: '盘点范围',
        message: `${inventoryScopeText}`,
        showCancelButton: false,
        confirmButtonText: '我知道了',
        confirmButtonColor: '#4eabf0'
      }).then(() => {
      });
    },
    // 获取详情相关数据
    async getDetail() {
      let id = this.$route.query.id;
      // 上架任务详情 基本信息
      itaskDetail({id: id}).then((res) => {
        if (res.code == 200 && res.result) {
          this.detailInfo = res.result;
        } else {
          this.$toast(res.message);
        }
      });
    },
    //删除
    handleDelete() {
      Dialog.confirm({
        title: '确定删除盘点单吗？',
        message: '盘点单删除，对应盘点范围内的库区、库位释放，不再是盘点状态。',
        confirmButtonColor: '#2b85e4'
      }).then(() => {
        deleteItask({id: this.detailInfo.id}).then((res) => {
          if (res.success) {
            this.$toast('盘点单删除成功');
            this.searchQuery()
          } else {
            this.$toast(res.message);
          }
        });
      }).catch(() => {

      })
    },
    // 继续盘点
    handleContinue() {
      this.$router.push({
        path: "/inventoryItaskForm",
        query: {
          id:  this.detailInfo.id
        }
      });
    },
    // 盈亏处理
    handleProOrLoss() {
      Dialog.confirm({
        title: '确定进行盈亏处理吗？',
        message: '',
        confirmButtonColor: '#2b85e4'
      }).then(() => {
        profitLossOperation({id:  this.detailInfo.id}).then((res) => {
          if (res.success) {
            this.$toast('盘点单盈亏处理成功');
            this.$router.go(-1);
          } else {
            this.$toast(res.message);
          }
        });
      }).catch(() => {

      })
    },
    // 撤销盈亏
    revokeProOrLoss() {
      Dialog.confirm({
        title: '确定进行撤销盈亏吗？',
        message: '',
        confirmButtonColor: '#2b85e4'
      }).then(() => {
        revokedProfitLoss({id: this.detailInfo.id}).then((res) => {
          if (res.success) {
            this.$toast('盘点单撤销盈亏成功');
            this.$router.go(-1);
          } else {
            this.$toast(res.message);
          }
        });
      }).catch(() => {

      })
    }
  },
};
</script>
<style lang="scss" scoped>
.recordDetail {
  height: 100vh;
  overflow: hidden;
  .d-head {
    width: 100%;
    padding: 32px;
    background: #ffffff;
    margin: 10px 0;
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        flex: 1;
        .title {
          font-size: 32px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #191f25;
          line-height: 32px;

          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          display: flex;
          justify-content: space-between;
          .UN {
            color: #969696
          }
          .ING {
            color: #1890ff;
          }
          .PENDING {
            color: #ff9900
          }
          .FINISH {
            color: #19be6b
          }
        }
        .row {
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 400;
          margin-top: 20px;
          display: flex;
          justify-content: flex-start;
          .key {
            display: block;
            color: #888888;
          }
          .value {
            display: block;
            color: #191f25;
            width: 500px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .ctrBtn-contian {
          height: 50px;
          text-align: center;
          color: #969696;
          font-size: 24px;
          line-height: 50px;
          /deep/.van-icon {
            top: 6px;
          }
        }
      }
      .right {
        flex: 1;
        .rightImg {
          display: block;
          width: 55px;
          height: 55px;
        }
      }
    }
  }

  .otherTaps {
    background: #ffffff;
    padding: 32px;
    margin-top: 20px;
    .title {
      padding-bottom: 20px;
      border-bottom: 1px solid #eeeeee;
      .icon {
        display: inline-block;
        width: 6px;
        height: 28px;
        background: #1890ff;
      }
      .content {
        width: 126px;
        height: 32px;
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #191f25;
        line-height: 44px;
        margin-left: 20px;
      }
    }
    .content {
      .row {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        margin-top: 32px;
        display: flex;
        .r-label {
          color: #888888;
          display: block;
        }
        .r-column {
          display: block;
          color: #191f25;
          width: 500px;
        }
      }
      .fhrow {
        display: flex;
        .fhImg {
          width: 0.55rem;
          height: 0.55rem;
          border-radius: 0.1rem;
        }
        .rt-column {
          width: 2.55rem;
          //   height: 2.55rem;
          margin-left: 0.2rem;
          .rt-title {
            font-size: 0.16rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #191f25;
            margin-bottom: 0.16rem;
          }
          .rt-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 0.23rem;
            .column {
              //    border: 1px solid red;
              width: 1.5rem;
              .column-t {
                font-size: 0.14rem;
                font-family: PingFang SC;
                font-weight: 400;
                color: #888888;
                display: block;
                width: 100%;
                margin-bottom: 0.03rem;
              }
              .column-c {
                font-size: 0.16rem;
                font-family: PingFang SC;
                font-weight: 400;
                color: #191f25;
                display: block;
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
  .search-bottom {
    width: 100%;
    height: 100px;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0px;
    padding: 0 11px;
    box-sizing: border-box;
    font-size: 32px;
    font-weight: 500;
    z-index: 9;
    .searchContain {
      .btn {
        display: inline-block;
        box-sizing: border-box;
        padding: 0px 30px;
        height: 64px;
        align-items: center;
        border-radius: 6px;
        margin-right: 18px;
        text-align: center;
        line-height: 64px;
      }
      .confirm {
        background: #1890ff;
        color: #ffffff;
      }
      .cancel {
        border: 1px solid #b2b2b2;
        background: #f6f6f6;
        color: #5a5a5a;
      }
      .del{
        background: #ff5f4e;
        color: #fff;
      }
    }
  }
}
.contentBox {
  margin-top: 1.38rem;
}

.otherMargin {
  height: 0.1rem;
  background: #f5f5f5;
}
.bottomLine {
  height: 0.01rem;
  background-color: #f0f0f0;
  margin: 0.16rem 0.16rem 0 0.06rem;
}
.ExamineBottom {
  height: 0.5rem;
}
.status {
  display: inline-block;
  margin-top: 0.16rem;
  padding: 0.03rem 0.08rem;
  background: #edf6ff;
  border-radius: 0.02rem;
  font-size: 0.11rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #3774ac;
}
.list {
  height: 67vh;
  overflow: scroll;
  .wrap {
    background: #fff;
    margin: 24px 0;
    padding: 30px;
    width: 100vw;
    .top {
      display: flex;
      justify-content: flex-start;
      .icon {
        width: 6px;
        height: 36px;
        background: #1890ff;
        margin-top: 6px;
        margin-right: 20px;
      }
      .title {
        width: 620px;
        margin-right: 20px;
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #191f25;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        justify-content: space-between;
      }
      .spot img {
        width: 40px;
        height: 40px;
      }
    }
    .center {
      p {
        margin: 16px 25px;
        font-size: 28px;
        display: flex;
        position: relative;
        .key {
          color: #888888;
        }
        .value {
          flex: 1;
          color: #191f25;
          width: 380px;
          display: block;
          overflow: hidden;
          white-space: nowrap;
        }
        .arrow {
          color: #1890ff;
          // float: right;
          // margin-right: -0.05rem;
          // display: block;
          position: absolute;
          right: -10px
        }
        .fontAno {
          font-size: 30px;
          padding-left: 20px;
        }
      }
      .showAll {
        background: #f5f8ff;
        width: 100vw;
        margin-left: -0.15rem;
        padding: 0.15rem;
        margin-bottom: 0.15rem;
      }
    }
    .label {
      margin-left: -0.03rem;
      margin-top: -0.1rem;
      span {
        height: 0.16rem;
        background: #f0f6fe;
        color: #1890ff;
        margin-right: 0.1rem;
        padding: 0.03rem 0.08rem;
        font-size: 24px;
        border-radius: 0.03rem;
      }
    }
    .foot {
      // height: 0.33rem;
      // line-height: 0.33rem;
      display: flex;
      justify-content: space-between;
      // margin: 0.15rem 0.12rem 0 0.12rem;
      font-size: 0.14rem;
      .pictures {
        width: 0.33rem;
        height: 0.33rem;
        line-height: 0.33rem;
        text-align: center;
        color: #fff;
        background: #1890ff;
        display: block;
        border-radius: 0.06rem;
        font-size: 0.12rem;
        margin-right: 0.1rem;
      }
      .text {
        width: 1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .opera {
        color: #1890ff;
        font-size: 0.14rem;
      }
    }
  }
}
</style>
